import { Link } from "react-router-dom";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "./ui/dropdown-menu";
import { Button } from "./ui/button";
import { ArrowLeft, Shield, UserCircle, HelpCircle, LogOut } from "lucide-react";

/**
 * Top nav for the Admin Panel. Stateless — owns no data, all callbacks
 * passed in by the parent.
 */
export function AdminNav({ user, onHelp, onLogout }) {
  return (
    <nav className="bg-white border-b border-stone sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 py-3 flex items-center justify-between">
        <div className="flex items-center gap-4">
          <Link
            to="/dashboard"
            className="flex items-center gap-2 text-stone-dark/60 hover:text-stone-dark transition-colors"
            data-testid="back-to-dashboard"
          >
            <ArrowLeft className="w-4 h-4" />
            <span className="hidden sm:inline">Dashboard</span>
          </Link>
          <div className="h-6 w-px bg-stone" />
          <div className="flex items-center gap-2">
            <div className="w-8 h-8 rounded-full bg-sage flex items-center justify-center">
              <Shield className="w-4 h-4 text-white" />
            </div>
            <span className="font-serif font-semibold text-lg text-stone-dark">Admin Panel</span>
          </div>
        </div>
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <Button variant="ghost" className="flex items-center gap-2" data-testid="admin-user-menu">
              <UserCircle className="w-5 h-5 text-stone-dark/70" />
              <span className="hidden sm:inline text-stone-dark">{user?.name}</span>
            </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="end" className="w-48">
            <DropdownMenuItem className="text-stone-dark/70">{user?.email}</DropdownMenuItem>
            <DropdownMenuSeparator />
            <DropdownMenuItem onClick={onHelp} data-testid="admin-help-btn">
              <HelpCircle className="w-4 h-4 mr-2" />Help &amp; Support
            </DropdownMenuItem>
            <DropdownMenuItem onClick={onLogout} className="text-red-600" data-testid="admin-logout-btn">
              <LogOut className="w-4 h-4 mr-2" />Sign Out
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      </div>
    </nav>
  );
}
